import { render } from "./EventGridComponent.vue?vue&type=template&id=5812631e&scoped=true&ts=true"
import script from "./EventGridComponent.vue?vue&type=script&lang=ts"
export * from "./EventGridComponent.vue?vue&type=script&lang=ts"

import "./EventGridComponent.vue?vue&type=style&index=0&id=5812631e&scoped=true&lang=css"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5812631e"]])

export default __exports__